"use strict";
/*
 * Created on 09 10 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var RegularProductPrice_1 = require("./RegularProductPrice");
/**
 * <p>The basic representation of encapsulation of prices related to specific price zone. Can be used as a superclass for other types.</p>
 *
 * @author Jaroslav Sevcik
 * @author JMe
 */


var ZonePrices =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ZonePrices, _DomainObject_1$Domai);

  /**
   *
   * @param priceZoneId Corresponds to {@link PriceZone.id}.
   * @param regularPrice Regular price related to the price zone. Null if it cannot be determined.
   */
  function ZonePrices(priceZoneId, regularPrice) {
    var _this;

    _classCallCheck(this, ZonePrices);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ZonePrices).call(this));
    _this.priceZoneId = priceZoneId;
    _this.regularPrice = regularPrice;
    return _this;
  }

  _createClass(ZonePrices, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new ZonePrices(mat.priceZoneId, mat.regularPrice);
    }
  }]);

  return ZonePrices;
}(DomainObject_1.DomainObject);

exports.ZonePrices = ZonePrices;

ZonePrices.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ZonePrices.name);
  return {
    priceZoneId: builder.str('priceZoneId'),
    regularPrice: builder.opt(builder.obj('regularPrice', RegularProductPrice_1.RegularProductPrice.productPriceSchema, function (mat) {
      return RegularProductPrice_1.RegularProductPrice.fromDataDict(mat);
    }))
  };
}();